"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "More options": "その他のオプション",
  "Press enter to explore {overflowItems} more actions.": ["Enter キーを押すと、さらに ", ["overflowItems"], " 個のアクションが表示されます。"]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map